import { useNavigate } from "react-router-dom";
import { Flex, Menu as AntMenu } from "antd";
import { observer } from "mobx-react-lite";

import { allMenuItems } from "./menuItems";
import { useStores } from "stores";
import { routes } from "constants/routes";
import styles from "./menu.module.css";
import { EllipsisOutlined } from "@ant-design/icons";

export const HorizontalMenu = observer(() => {
  const navigate = useNavigate();
  const { user, pendingStatistics } = useStores();

  const menuItems = allMenuItems
    .filter((item) => item.roles.some((role) => user.scope.includes(role)))
    .map((item) => {
      let count;
      if (item.key === `/${routes.pendingActions}` && item.type === "item") {
        count = pendingStatistics.indicators?.total || 0;
      }
      return {
        ...item,
        className: styles.menuItem,
        label: (
          <Flex align="start" gap={5}>
            <div className={styles.menuItemLabel}>{item.label}</div>
            {count ? <span>({count})</span> : null}
          </Flex>
        ),
      };
    });

  const currentKey =
    (menuItems.find((item) => window.location.pathname.startsWith(item.key as string))?.key as string) ?? "/";

  return (
    <AntMenu
      id="main-menu"
      mode="horizontal"
      overflowedIndicator={<EllipsisOutlined />}
      selectedKeys={[currentKey]}
      onSelect={(e) => navigate(e.key)}
      onClick={(e) => {
        if (window.location.pathname !== e.key && window.location.pathname.startsWith(e.key)) {
          navigate(e.key);
        }
      }}
      items={menuItems}
    />
  );
});
